import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { isString } from 'util';
import { FlowDesignerService } from './flow-designer.service';
import { CyElement } from './interfaces';
import * as cytoscape from 'cytoscape';
import { NgFlowDesignerComponent } from './ng-flow-designer.component';

@Directive({
  selector: '[ngFlowDesignerNode]',
  host: { class: 'node' },
})
export class NgFlowDesignerNodeDirective implements OnInit, OnDestroy, CyElement {
  @Input('ngFlowDesignerNode') id: string;
  @Input() x: number;
  @Input() y: number;
  @Output() dragStart: EventEmitter<any> = new EventEmitter();
  @Output() dragStop: EventEmitter<any> = new EventEmitter();

  @Input() set locked(val: boolean) {
    this._locked = val;
    if (!this.cy) {
      return;
    }
    // @ts-ignore
    if (this._locked) {
      this.getCyElement().lock();
    } else {
      this.getCyElement().unlock();
    }
  }

  get locked(): boolean {
    return this._locked;
  }

  isRegistered = false;
  private cy: cytoscape.Core;
  private _locked = false;

  constructor(
    public host: ElementRef,
    private view: ViewContainerRef,
    private flowDesignerService: FlowDesignerService,
    private designerComponent: NgFlowDesignerComponent,
  ) {}

  @HostListener('mousedown', ['$event'])
  @HostListener('mouseup', ['$event'])
  @HostListener('contextmenu', ['$event'])
  stopPropagation(e) {
    if (e.type === 'mouseup' && this.flowDesignerService.mousedown) {
      this.flowDesignerService.mousedown = false;
      return;
    }
    if (e.target.classList.contains('allow-event-propagate') || this.designerComponent.startedGhostEdge) {
      return;
    }

    return e.stopPropagation();
  }

  isLocked() {
    return this._locked;
  }

  ngOnInit() {
    if (isString(this.x)) {
      // @ts-ignore
      this.x = parseFloat(this.x);
    }
    if (isString(this.y)) {
      // @ts-ignore
      this.y = parseFloat(this.y);
    }

    this.registerCy(this.designerComponent.cy);
  }

  ngOnDestroy() {
    this.cy.remove(this.getCyElement());
  }

  registerCy(cy: cytoscape.Core) {
    this.cy = cy;
    this.cy.add({
      data: {
        id: this.id,
        directive: this,
        isNode: true,
      },
    });
    const cyNode = this.getCyElement();
    cyNode.position({
      x: this.x,
      y: this.y,
    });

    if (this._locked) {
      this.getCyElement().lock();
    }
    this.isRegistered = true;
  }

  getCyElement(): cytoscape.CollectionReturnValue {
    return this.cy.getElementById(this.id);
  }
}
